import { contents } from "@/mocks/contents";
import { categories } from "@/mocks/categories";
import type { ContentItem } from "@/types/content";

export function getContentById(id: string): ContentItem | undefined {
  return contents.find((item) => item.id === id);
}

export function getCategoryById(id: string) {
  return categories.find((item) => item.id === id);
}

export function getContentsByCategory(categoryId: string): ContentItem[] {
  return contents.filter((item) => item.categoryId === categoryId);
}

export function searchContents(keyword: string): ContentItem[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return contents.filter((item) => {
    const haystack = [
      item.title,
      item.summary,
      item.director,
      item.cast.join(" "),
      item.genres.join(" "),
      item.tags.join(" "),
      item.region,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRelatedContents(item: ContentItem, limit = 4): ContentItem[] {
  const scored = contents
    .filter((c) => c.id !== item.id)
    .map((c) => {
      let score = 0;
      if (c.categoryId === item.categoryId) score += 3;
      score += c.genres.filter((g) => item.genres.includes(g)).length * 2;
      score += c.tags.filter((t) => item.tags.includes(t)).length;
      return { item: c, score };
    })
    .filter((s) => s.score > 0)
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views);
  return scored.slice(0, limit).map((s) => s.item);
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function getAllGenres(): string[] {
  const set = new Set<string>();
  contents.forEach((c) => c.genres.forEach((g) => set.add(g)));
  return Array.from(set);
}

export function getAllRegions(): string[] {
  const set = new Set<string>();
  contents.forEach((c) => set.add(c.region));
  return Array.from(set);
}

export function getAllYears(): number[] {
  const set = new Set<number>();
  contents.forEach((c) => set.add(c.year));
  return Array.from(set).sort((a, b) => b - a);
}